import { SVGProps, Ref, forwardRef } from 'react';

export const IbsSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M11.61 12.677a.47.47 0 0 1 .461.46.454.454 0 0 1-.464.456l.003.003h-.92v-.92z"
                fill="currentColor"
            />
            <path
                d="M11.57 10.413a.447.447 0 0 1 .434.438.454.454 0 0 1-.44.441l-.877-.003v-.876z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 22a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2zM4.146 10.413h.512v3.174h-.512v1.468h3.316v-1.468h-.513v-3.174h.513V8.945H4.146zm3.93.006h.513v3.168h-.513v1.467h4.637a1.687 1.687 0 0 0 1.58-1.715A1.53 1.53 0 0 0 13.26 11.9l.006-.024a1.42 1.42 0 0 0 .829-1.394c0-.79-.615-1.532-1.677-1.532H8.076zM16.72 8.95c-1.188 0-2.122.702-2.122 1.897a1.835 1.835 0 0 0 1.173 1.713c.23.09.475.131.721.124h1.25a.463.463 0 0 1 .461.46.46.46 0 0 1-.46.46h-.922v-.45h-1.904v1.899h3.467a1.904 1.904 0 0 0 1.907-1.902 1.873 1.873 0 0 0-1.913-1.863l-1.269.003a.45.45 0 0 1-.438-.441.44.44 0 0 1 .438-.438h.88v.429h1.887v-1.89z"
                fill="currentColor"
            />
        </g>
    </svg>
));
IbsSolidSize24Glyph.displayName = 'IbsSolidSize24Glyph';
